import styled from 'styled-components';

export const Container = styled.div`
  & > .hefesto-side-sheet {
    /* position: relative; */

    z-index: 2;
    .hefesto-side-sheet-container__close-btn {
      align-self: center;
    }

    aside.hefesto-side-sheet-container .hefesto-side-sheet-container__content {
      height: 90vh;
      position: relative;
    }

    aside.hefesto-side-sheet-container
      header.hefesto-side-sheet-container__header
      h4.hefesto-side-sheet-container__title {
      font-weight: 600;
      font-size: 1.5rem;
      color: ${({ theme }) => theme.colors.grayDark3};
    }

    aside.hefesto-side-sheet-container
      header.hefesto-side-sheet-container__header {
      padding: 1.5rem 1rem;
    }

    & > .hefesto-side-sheet-container {
      width: 31rem;
    }
  }
`;

export const SideSheetContainer = styled.div`
  height: 100%;

  color: ${({ theme }) => theme.colors.grayDark4};
  font-family: ${({ theme }) => theme.fonts.workSans};
`;

export const Footer = styled.div`
  position: fixed;
  bottom: 1rem;
  width: 464px;
  input {
    padding-left: 1rem;
  }

  background-color: ${({ theme }) => theme.colors.white};

  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const FooterButtons = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: fit-content;
  overflow-y: scroll;
  margin-top: 0.75rem;
`;

export const Subtitle = styled.span``;
